import { render, staticRenderFns } from "./messageVC.vue?vue&type=template&id=76c08b42&scoped=true"
import script from "./messageVC.vue?vue&type=script&lang=js"
export * from "./messageVC.vue?vue&type=script&lang=js"
import style0 from "./messageVC.vue?vue&type=style&index=0&id=76c08b42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c08b42",
  null
  
)

export default component.exports